import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { appendCamelCaseJsonHeader } from '@rma/generic/ng/http';
import { appendToRmaApiUrl } from '@rma/generic/ng/util';
import { Observable } from 'rxjs';
import { AvailableProfiles, AvailableProfilesRequest } from './domain/available-profiles.model';
import { CurrentUser } from './domain/current-user.models';

@Injectable({
  providedIn: 'root',
})
export class CurrentUserApiService {
  private readonly httpClient: HttpClient = inject(HttpClient);
  private readonly rmaApiUrl = inject(appendToRmaApiUrl);

  public getCurrentUser(): Observable<CurrentUser> {
    return this.httpClient.get<CurrentUser>(this.rmaApiUrl('v2/Users/Me'), appendCamelCaseJsonHeader());
  }

  public getAvailableAgentProfiles(request: AvailableProfilesRequest = { take: 10 }): Observable<AvailableProfiles> {
    return this.httpClient.post<AvailableProfiles>(
      this.rmaApiUrl('v1/Users/Me/RetrieveAvailableProfiles/Agent'),
      { ...request },
      appendCamelCaseJsonHeader(),
    );
  }

  public getAvailableAgencyProfiles(request: AvailableProfilesRequest = { take: 10 }): Observable<AvailableProfiles> {
    return this.httpClient.post<AvailableProfiles>(
      this.rmaApiUrl('v1/Users/Me/RetrieveAvailableProfiles/Agency'),
      { ...request },
      appendCamelCaseJsonHeader(),
    );
  }
}
